





























helpers = require('../../helpers.coffee')
summernote = require('../../libraries/summernote_comments.coffee')

module.exports = {
  data: ->
    showSummernote: false
    description_num_of_char: 210

  props: ['event','contact']

  methods:
    toogleSummernote: ->
      @showSummernote = !@showSummernote

    inializeSummernote: ->
      @$comment = jQuery('#'+@element_id)
      summernote(@$comment)

    removeComment: ->
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-remove-comment'+@event.id

    confirmRemoveComment:->
      params = { id: @event.id }
      @comment_events_resource.destroy @destroySuccess, @unknownError, params

    destroySuccess: ->
      alertify.success 'Comentário excluído com sucesso!'
      @$emit 'event-destroyed', @event

    updateComment: ->
      comment_text = @$comment.summernote('code')
      if comment_text.length == 0 || comment_text == '&nbsp;'
        alertify.error 'Não é possível inserir um comentário sem conteúdo'
        return

      Loader.on()
      params = {
        id: @event.id
        author: @event.author
        edition_author: Session.current_user.name
        comment: comment_text
       }
      @comment_events_resource.update @updateSuccess, @unknownError, params
      @showSummernote = !@showSummernote

    updateSuccess: (data) ->
      Loader.off()
      alertify.success 'O comentário foi atualizado com sucesso!'
      @$emit 'event-updated', data.event

    setSummernoteCode: ->
      @$comment.summernote('code', @event.comment) if @event.comment

    treatSummernote: ->
      @inializeSummernote()
      @setSummernoteCode()

    initializeEditor: ->
      @treatSummernote()
      jQuery('[data-toggle="tooltip"]').tooltip('destroy')
      jQuery('[data-toggle="tooltip"]').tooltip()

  computed:
    modal_id: ->
      'confirm-remove-comment'+@event.id

    description: ->
      @event.comment

    element_id: ->
      'comment'+@event.id

    has_edition: ->
      @event.created_at < @event.updated_at

    short_description: ->
      if @stripped_content != null && @stripped_content.length > @description_num_of_char
        @stripped_content.substring(0,@description_num_of_char) + '...'
      else
        if @stripped_content.length > 0
          @stripped_content
        else
          '[imagem]'

    stripped_content: ->
      regex = /(<([^>]+)>)/ig
      content = @description.replace(regex, "")
      content.replace(/&nbsp;/gi,'')

    comment_events_resource: ->
      new CommentEventsResource @contact.id

    user_can_edit: ->
      Session.current_user.id == @contact.user_id || ( Session.current_user.isAdmin() || Session.current_user.isManager() )

  updated: ->
    @initializeEditor()

  mounted: ->
    @initializeEditor()
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/events/comment_event.vue